PageApp.Ent.AccountIcons = Backbone.Model.extend({
  url: function () {
    return myApp.ent.config.attributes.contextPath + '/accountIcons'
  },
  startTimer: function () {
    if (!myApp.ent.header.get('myAccountRefreshRate') || myApp.ent.header.get('myAccountRefreshRate') === 0) {
      return
    }
    var $accIconsElf = this
    setInterval(function () {
      $accIconsElf.fetch()
    }, myApp.ent.header.get('myAccountRefreshRate'))
  }
})
